"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[935],{

/***/ 1000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/menu/MenuBase.tsx
var MenuBase = __webpack_require__(6775);
// EXTERNAL MODULE: ./config.ts
var config = __webpack_require__(8288);
// EXTERNAL MODULE: ./redux/hooks.ts
var hooks = __webpack_require__(6410);
// EXTERNAL MODULE: ./redux/layoutSlice.ts
var layoutSlice = __webpack_require__(7794);
// EXTERNAL MODULE: ./xFrame4/components/Hooks.ts + 3 modules
var Hooks = __webpack_require__(8611);
// EXTERNAL MODULE: ./xFrame4/components/next/ALink.tsx
var ALink = __webpack_require__(2768);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/menu/MobileMenu.tsx








var MobileMenu = function(props) {
    var t = (0,Hooks/* useTranslate */.qM)();
    var dispatch = (0,hooks/* useAppActionDispatch */.a)();
    var isMobileMenuOpen = (0,hooks/* useAppStateSelector */.k)(function(state) {
        return state.layout.isMobileMenuOpen;
    });
    var language = (0,hooks/* useAppStateSelector */.k)(function(state) {
        return state.layout.language;
    });
    /** Disable body scroll when menu is open */ (0,react.useEffect)(function() {
        if (isMobileMenuOpen) {
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";
        } else {
            document.documentElement.style.overflow = "auto";
            document.body.style.overflow = "auto";
        }
    }, [
        isMobileMenuOpen
    ]);
    /** Menu items */ var cmpMenuItems = props.menuItems.filter(function(menuItem) {
        return menuItem.position == MenuBase/* MenuPosition.Both */.Em.Both || menuItem.position == MenuBase/* MenuPosition.Header */.Em.Header;
    }).map(function(menuItem) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mobile-menu-item text-uppercase text-center fw-bold font-size-5 mb-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ALink/* default */.Z, {
                href: config/* default.appUrl */.Z.appUrl + language.code + "/" + menuItem.link,
                className: "text-white",
                onClick: function() {
                    return dispatch((0,layoutSlice/* setIsMobileMenuOpen */.xe)(false));
                },
                children: t(menuItem.name)
            })
        }, menuItem.name);
    });
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mobile-menu " + (isMobileMenuOpen ? "mobile-menu-state-open" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mobile-menu-inner bg-primary text-white w-100 h-100",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-menu-top d-flex justify-content-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-1 pe-3",
                        onClick: function() {
                            return dispatch((0,layoutSlice/* setIsMobileMenuOpen */.xe)(false));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fa-solid fa-xmark text-white font-size-5"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-menu-items d-flex flex-column pt-5",
                    children: cmpMenuItems
                })
            ]
        })
    });
};
/* harmony default export */ var menu_MobileMenu = (MobileMenu);

// EXTERNAL MODULE: ./xFrame4/business/AppSetting.ts
var AppSetting = __webpack_require__(4851);
;// CONCATENATED MODULE: ./components/footer/Footer.tsx







var Footer = function(props) {
    var t = (0,Hooks/* useTranslate */.qM)();
    var language = (0,hooks/* useAppStateSelector */.k)(function(state) {
        return state.layout.language;
    });
    var facebookPage = AppSetting/* default.getValueFromArray */.Z.getValueFromArray(props.appSettings, "facebook_page");
    var instagramPage = AppSetting/* default.getValueFromArray */.Z.getValueFromArray(props.appSettings, "instagram_page");
    /** Social icons */ var socialIcons = [
        /*
        {
            icon: 'fa-brands fa-facebook-f',
            link: facebookPage.url,
            alt: facebookPage.name
        },
        */ {
            icon: "fa-brands fa-instagram",
            link: instagramPage.url,
            alt: instagramPage.name
        },
        {
            icon: "fa-regular fa-envelope",
            link: config/* default.appUrl */.Z.appUrl + language.code + "/contact",
            alt: t("EMAIL")
        }, 
    ];
    var cmpSocialIcons = socialIcons.map(function(socialIcon) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "footer-social-icon",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ALink/* default */.Z, {
                href: socialIcon.link,
                target: "_blank",
                className: "text-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: socialIcon.icon + " me-4"
                })
            }, socialIcon.icon)
        }, socialIcon.icon);
    });
    /** Menu items: Position 1 */ var cmpPosition1MenuItems = props.menuItems.filter(function(menuItem) {
        return menuItem.footerPosition == MenuBase/* FooterMenuPosition.Position1 */.M1.Position1;
    }).map(function(menuItem) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "footer-menu-item me-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ALink/* default */.Z, {
                href: config/* default.appUrl */.Z.appUrl + language.code + "/" + menuItem.link,
                className: "text-white",
                children: t(menuItem.name)
            })
        }, menuItem.name);
    });
    /** Menu items: Position 2 */ var cmpPosition2MenuItems = props.menuItems.filter(function(menuItem) {
        return menuItem.footerPosition == MenuBase/* FooterMenuPosition.Position2 */.M1.Position2;
    }).map(function(menuItem) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "footer-menu-item me-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ALink/* default */.Z, {
                href: config/* default.appUrl */.Z.appUrl + language.code + "/" + menuItem.link,
                className: "text-white",
                children: t(menuItem.name)
            })
        }, menuItem.name);
    });
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "bg-primary text-white font-size-n85 pb-env",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container py-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-6 col-lg-8 mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-3",
                                    children: t("LOGO_TEXT")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-lg-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ALink/* default */.Z, {
                                        href: config/* default.appUrl */.Z.appUrl + language.code + "/contact",
                                        className: "text-white",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fa-regular fa-envelope me-3"
                                            }),
                                            t("CONTACT")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "footer-menu-items-position-1 d-block d-lg-flex flex-wrap mb-3",
                                    children: cmpPosition1MenuItems
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-6 col-lg-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "footer-social-icons d-flex mb-3",
                                    children: cmpSocialIcons
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "footer-menu-items-position-2 d-block d-lg-flex flex-wrap mb-3",
                                    children: cmpPosition2MenuItems
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-none d-lg-block",
                                    children: t("FOOTER_COPYRIGHT")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "d-flex d-lg-none justify-content-center mt-5",
                    children: t("FOOTER_COPYRIGHT")
                })
            ]
        })
    });
};
/* harmony default export */ var footer_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(6626);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(2951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(7283);
// EXTERNAL MODULE: ./graphql/apollo-client.ts + 1 modules
var apollo_client = __webpack_require__(8969);
;// CONCATENATED MODULE: ./xFrame4/common/Tracker.ts








var TrackerEcommerceEventType;
(function(TrackerEcommerceEventType) {
    TrackerEcommerceEventType[TrackerEcommerceEventType["ViewProducts"] = 0] = "ViewProducts";
    TrackerEcommerceEventType[TrackerEcommerceEventType["AddToWishList"] = 1] = "AddToWishList";
    TrackerEcommerceEventType[TrackerEcommerceEventType["AddToCart"] = 2] = "AddToCart";
    TrackerEcommerceEventType[TrackerEcommerceEventType["RemoveFromCart"] = 3] = "RemoveFromCart";
    TrackerEcommerceEventType[TrackerEcommerceEventType["ViewCart"] = 4] = "ViewCart";
    TrackerEcommerceEventType[TrackerEcommerceEventType["InitiateCheckout"] = 5] = "InitiateCheckout";
    TrackerEcommerceEventType[TrackerEcommerceEventType["AddPaymentInfo"] = 6] = "AddPaymentInfo";
    TrackerEcommerceEventType[TrackerEcommerceEventType["Purchase"] = 7] = "Purchase";
    TrackerEcommerceEventType[TrackerEcommerceEventType["Refund"] = 8] = "Refund";
})(TrackerEcommerceEventType || (TrackerEcommerceEventType = {}));
/**
 * Track user interactions with the app.
 */ var Tracker = /*#__PURE__*/ function() {
    "use strict";
    function Tracker() {
        (0,_class_call_check/* default */.Z)(this, Tracker);
        this.enabled = true;
        this.trackWithGoogle = false;
        this.trackWithFacebook = false;
        this.trackWithFacebookConversionsApi = false;
        this.initGoogle();
        this.initFacebook();
    }
    var _proto = Tracker.prototype;
    /**
    * Init the Google Analytics tracking code.
    * https://developers.google.com/analytics/devguides/collection/gtagjs
    * https://developers.google.com/tag-platform/tag-manager/web/datalayer
    * https://support.google.com/google-ads/answer/7548399
    * https://support.google.com/google-ads/answer/12785474?visit_id=638155969923163305-1440919079&rd=1#
    */ _proto.initGoogle = function initGoogle() {
        // Load the tracking script
        var script = document.createElement("script");
        script.src = "https://www.googletagmanager.com/gtag/js?id=" + config/* default.googleAnalyticsId */.Z.googleAnalyticsId;
        script.async = true;
        document.body.appendChild(script);
        // Initialize the data layer (events in the data layer will be sent to Google as soon as the gtag script has been loaded)
        window.dataLayer = window.dataLayer || [];
        this.gtag = function() {
            window.dataLayer.push(arguments);
        };
        this.gtag("js", new Date());
        this.gtag("config", config/* default.googleAnalyticsId */.Z.googleAnalyticsId, {
            "send_page_view": false
        });
        // Google Ads tag
        if (config/* default.googleAdsId */.Z.googleAdsId != null) {
            this.gtag("config", config/* default.googleAdsId */.Z.googleAdsId, {
                "allow_enhanced_conversions": true
            });
        }
    };
    /**
    * Initialize Facebook pixel code.
    * https://www.facebook.com/business/help/952192354843755?id=1205376682832142
    */ _proto.initFacebook = function initFacebook() {
        var f = function f(f1, b, e, v, n, t, s) {
            if (f1.fbq) return;
            n = f1.fbq = function() {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f1._fbq) f1._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        };
        f(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
        //fbq('set', 'autoConfig', 'false', config.facebookPixelID); 
        fbq("init", config/* default.facebookPixelId */.Z.facebookPixelId);
        this.fbq = fbq;
    };
    /**
    * Log a custom event.
    * https://developers.google.com/analytics/devguides/collection/ga4/events?client_type=gtag
    * https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking
    * 
    * @param name 
    * @param parameters 
    * @param extraUserData
    */ _proto.logEvent = function logEvent(name) {
        var parameters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, extraUserData = arguments.length > 2 ? arguments[2] : void 0;
        var ref;
        // Google
        this.logGoogleEvent(name, parameters);
        // Facebook
        this.logFacebookEvent(name, parameters);
        // Facebook Conversions API
        this.logFacebookConversionsApiEvent(name, window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href, parameters, extraUserData);
    };
    /**
    * Log a page view (Google only).
    * https://developers.google.com/analytics/devguides/collection/gtagjs/pages
    * https://developers.facebook.com/docs/meta-pixel/reference#standard-events
    */ _proto.logPageView = function logPageView() {
        var pageTitle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.title, pageUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : location.href, extraUserData = arguments.length > 2 ? arguments[2] : void 0;
        // Google
        var parameters = {
            page_title: pageTitle,
            page_location: pageUrl
        };
        this.logGoogleEvent("page_view", parameters);
        // Facebook
        parameters = {
            content_name: pageTitle
        };
        this.logFacebookEvent("ViewContent", parameters);
        // Facebook Conversions API
        this.logFacebookConversionsApiEvent("ViewContent", pageUrl, parameters, extraUserData);
    };
    /**
     * Log an eCommerce related event.
     * 
     * @param data eCommerce data
     * @param extraUserData
     */ _proto.logEcommerceEvent = function logEcommerceEvent(data, extraUserData) {
        var ref;
        // Google data
        // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#purchase
        var googleData = {
            transaction_id: data.transactionId,
            value: data.value,
            tax: data.tax,
            shipping: data.shippingCost,
            currency: data.currency,
            coupon: data.couponCode,
            payment_type: data.paymentType,
            items: data.products.map(function(product) {
                return {
                    item_id: product.name,
                    item_name: product.name,
                    price: product.price,
                    quantity: product.quantity,
                    item_category: product.category,
                    item_brand: product.brand,
                    item_variant: product.variant
                };
            })
        };
        // Facebook data
        // https://developers.facebook.com/docs/meta-pixel/reference#standard-events
        var facebookData = {
            currency: data.currency,
            value: data.value,
            content_type: "product",
            contents: data.products.map(function(product) {
                return {
                    id: product.id,
                    title: product.name,
                    item_price: product.price,
                    quantity: product.quantity
                };
            })
        };
        // Event name
        var googleEventName = "";
        var facebookEventName = "";
        switch(data.type){
            case TrackerEcommerceEventType.ViewProducts:
                {
                    googleEventName = "view_item";
                    facebookEventName = "ViewContent";
                }
                break;
            case TrackerEcommerceEventType.AddToWishList:
                {
                    googleEventName = "add_to_wishlist";
                    facebookEventName = "AddToWishlist";
                }
                break;
            case TrackerEcommerceEventType.AddToCart:
                {
                    googleEventName = "add_to_cart";
                    facebookEventName = "AddToCart";
                }
                break;
            case TrackerEcommerceEventType.RemoveFromCart:
                {
                    googleEventName = "remove_from_cart";
                    facebookEventName = "RemoveFromCart";
                }
                break;
            case TrackerEcommerceEventType.ViewCart:
                {
                    googleEventName = "view_cart";
                    facebookEventName = "ViewCart";
                }
                break;
            case TrackerEcommerceEventType.InitiateCheckout:
                {
                    googleEventName = "begin_checkout";
                    facebookEventName = "InitiateCheckout";
                }
                break;
            case TrackerEcommerceEventType.AddPaymentInfo:
                {
                    googleEventName = "add_payment_info";
                    facebookEventName = "AddPaymentInfo";
                }
                break;
            case TrackerEcommerceEventType.Purchase:
                {
                    googleEventName = "purchase";
                    facebookEventName = "Purchase";
                }
                break;
            case TrackerEcommerceEventType.Refund:
                {
                    googleEventName = "refund";
                    facebookEventName = "Refund";
                }
                break;
        }
        // Log event
        this.logGoogleEvent(googleEventName, googleData);
        this.logFacebookEvent(facebookEventName, facebookData);
        this.logFacebookConversionsApiEvent(facebookEventName, window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href, facebookData, extraUserData);
    };
    /**
    * Log a Google event with gtag.js.
    * https://developers.google.com/analytics/devguides/collection/gtagjs/events
    * https://developers.google.com/analytics/devguides/collection/ga4/events?client_type=gtag
    * 
    * @param name Event name. 
    * @param parameters Event parameters.
    */ _proto.logGoogleEvent = function logGoogleEvent(name) {
        var parameters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!this.enabled || !this.trackWithGoogle || this.gtag === undefined) return;
        if (parameters == null) parameters = {};
        parameters.version = config/* default.version */.Z.version;
        this.gtag("event", name, parameters);
    };
    /**
     * Log a Google Ads conversion event.
     * https://support.google.com/google-ads/answer/7548399 (Event snippet)
     * https://support.google.com/google-ads/answer/12785474?visit_id=638155969923163305-1440919079&rd=1# (Enhanced conversions)
     * 
     * @param conversionLabel The conversion label
     * @param parameters The conversion parameters.
     */ _proto.logGoogleAdsEvent = function logGoogleAdsEvent(conversionLabel) {
        var parameters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, extraUserData = arguments.length > 2 ? arguments[2] : void 0;
        if (!this.enabled || !this.trackWithGoogle || this.gtag === undefined) return;
        if (parameters == null) parameters = {};
        parameters.version = config/* default.version */.Z.version;
        // Google Ads enhanced conversion data
        if (extraUserData !== undefined && this.gtag !== undefined) {
            this.gtag("set", "user_data", {
                email: extraUserData.emails,
                phone_number: extraUserData.phoneNumbers
            });
        }
        // Log the event
        this.logGoogleEvent("conversion", (0,_object_spread/* default */.Z)({
            send_to: config/* default.googleAdsId */.Z.googleAdsId + "/" + conversionLabel
        }, parameters));
    };
    /**
    * Log a Facebook pixel event via JS
    * https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking/
    * 
    * @param name Event name. 
    * @param parameters Event parameters.
    */ _proto.logFacebookEvent = function logFacebookEvent(name) {
        var parameters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!this.enabled || !this.trackWithFacebook || this.fbq === undefined) return;
        if (parameters == null) parameters = {};
        parameters.version = config/* default.version */.Z.version;
        this.fbq("trackCustom", name, parameters);
    };
    /**
     * Log an event with the Facebook Conversion API.
     * 
     * @param name Event name.
     * @param sourceUrl The site URL where the event happened.
     * @param parameters Event parameters.
     */ _proto.logFacebookConversionsApiEvent = function logFacebookConversionsApiEvent(name, sourceUrl) {
        var parameters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, extraUserData = arguments.length > 3 ? arguments[3] : void 0;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var mutation, ref, ref1, input, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!_this.enabled || !_this.trackWithFacebookConversionsApi)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        mutation = "\n            mutation TrackWithFacebookConversionsApi($input: FacebookConversionApiInput!) {\n                trackWithFacebookConversionsApi(input: $input)\n            }\n        ";
                        ;
                        input = {
                            eventName: name,
                            eventSourceUrl: sourceUrl,
                            parameters: JSON.stringify(parameters),
                            userParameters: JSON.stringify({
                                emails: (ref = extraUserData === null || extraUserData === void 0 ? void 0 : extraUserData.emails) !== null && ref !== void 0 ? ref : [],
                                phones: (ref1 = extraUserData === null || extraUserData === void 0 ? void 0 : extraUserData.phoneNumbers) !== null && ref1 !== void 0 ? ref1 : []
                            })
                        };
                        _ctx.next = 7;
                        return apollo_client/* default.mutate */.Z.mutate({
                            mutation: (0,lib/* gql */.Ps)(mutation),
                            variables: {
                                input: input
                            }
                        });
                    case 7:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data.trackWithFacebookConversionsApi);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    Tracker.createInstance = function createInstance() {
        return new Tracker();
    };
    (0,_create_class/* default */.Z)(Tracker, null, [
        {
            key: "instance",
            get: function get() {
                if (this._instance === undefined) this._instance = this.createInstance();
                return this._instance;
            }
        }
    ]);
    return Tracker;
}();
/* harmony default export */ var common_Tracker = (Tracker);

;// CONCATENATED MODULE: ./business/tracking/AppTracker.ts




var AppTracker = /*#__PURE__*/ function(Tracker) {
    "use strict";
    (0,_inherits/* default */.Z)(AppTracker, Tracker);
    var _super = (0,_create_super/* default */.Z)(AppTracker);
    function AppTracker() {
        (0,_class_call_check/* default */.Z)(this, AppTracker);
        var _this;
        _this = _super.call(this);
        _this.trackWithGoogle = true;
        return _this;
    }
    AppTracker.createInstance = function createInstance() {
        var appTracker = new AppTracker();
        appTracker.enabled = false;
        return appTracker;
    };
    return AppTracker;
}(common_Tracker);

;// CONCATENATED MODULE: ./business/common/Constants.ts
var AppTrackerEvent;
(function(AppTrackerEvent) {
    AppTrackerEvent["CookieConsentShow"] = "cookie_consent_show";
    AppTrackerEvent["CookieConsentAccept"] = "cookie_consent_allow";
    AppTrackerEvent["CookieConsentDeny"] = "cookie_consent_deny";
})(AppTrackerEvent || (AppTrackerEvent = {}));
var AppTrackerEventCategory;
(function(AppTrackerEventCategory) {
    AppTrackerEventCategory["CookieConsent"] = "cookie_consent";
})(AppTrackerEventCategory || (AppTrackerEventCategory = {}));

// EXTERNAL MODULE: ./redux/trackerSlice.ts
var trackerSlice = __webpack_require__(6009);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js + 1 modules
var Button = __webpack_require__(3680);
;// CONCATENATED MODULE: ./components/gdpr/CookieConsent.tsx








var ALLOW_COOKIE_LOCAL_STORAGE_IDENTIFIER = "allow_cookies";
var CookieConsent = function(props) {
    var t = (0,Hooks/* useTranslate */.qM)();
    var dispatch = (0,hooks/* useAppActionDispatch */.a)();
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    /** Display logic */ (0,react.useEffect)(function() {
        var alreadyAsked = localStorage.getItem(ALLOW_COOKIE_LOCAL_STORAGE_IDENTIFIER) != null;
        var allow = alreadyAsked && localStorage.getItem(ALLOW_COOKIE_LOCAL_STORAGE_IDENTIFIER) == "1";
        if (!alreadyAsked) {
            setShow(true);
        } else {
            if (allow) dispatch((0,trackerSlice/* setAllowCookies */.hL)(true));
        }
    }, []);
    /** Enable/disable cookies. */ var allowCookies = function(allow) {
        localStorage.setItem(ALLOW_COOKIE_LOCAL_STORAGE_IDENTIFIER, allow ? "1" : "0");
    };
    /** Accept button clicked. */ var accept = function() {
        allowCookies(true);
        setShow(false);
        dispatch((0,trackerSlice/* setAllowCookies */.hL)(true));
        AppTracker.instance.logEvent(AppTrackerEvent.CookieConsentAccept, AppTrackerEventCategory.CookieConsent);
    };
    /** Deny button clicked. */ var deny = function() {
        allowCookies(false);
        setShow(false);
        dispatch((0,trackerSlice/* setAllowCookies */.hL)(false));
    };
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cookie-consent bg-white px-3 py-2 justify-content-end align-items-center",
        style: {
            display: show ? "block" : "none"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "row pb-env",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cookie-consent-text col-lg-8 mb-2 mb-lg-0 d-flex align-items-center",
                    children: t("GDPR_TEXT")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cookie-consent-buttons col-lg-4 d-flex justify-content-center justify-content-lg-end py-2 pe-lg-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "primary",
                            className: "cookie-consent-accept me-3",
                            onClick: function() {
                                return accept();
                            },
                            children: t("GDPR_ACCEPT")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "secondary",
                            className: "cookie-consent-deny",
                            onClick: function() {
                                return deny();
                            },
                            children: t("GDPR_DENY")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var gdpr_CookieConsent = (CookieConsent);

// EXTERNAL MODULE: ./xFrame4/components/SmoothImage.tsx
var SmoothImage = __webpack_require__(5423);
// EXTERNAL MODULE: ./xFrame4/common/Utils.ts + 1 modules
var Utils = __webpack_require__(7092);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/header/LanguageSelector.tsx






var LanguageSelector = function(props) {
    var t = (0,Hooks/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), showLanguageList = ref[0], setShowLanguageList = ref[1];
    (0,react.useEffect)(function() {
        var clickHandler = function(ev) {
            if (!ev.target.closest(".language-selector")) {
                setShowLanguageList(false);
            }
        };
        document.body.addEventListener("click", clickHandler);
        return function() {
            document.removeEventListener("click", clickHandler);
        };
    }, []);
    /** Language menu items */ var languageMenuItems = config/* default.languages.map */.Z.languages.map(function(language) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "language-list-item px-3 py-1 border border-gray-500",
            onClick: function() {
                router.push(config/* default.appUrl */.Z.appUrl + language.code);
                setShowLanguageList(false);
            },
            children: (0,Utils.tl)("APP_LANGUAGE", language.code)
        }, language.code);
    });
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "language-selector cursor-pointer position-relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "selected-language d-flex justify-content-end align-items-center",
                onClick: function() {
                    return setShowLanguageList(!showLanguageList);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "me-1",
                        children: t("APP_LANGUAGE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fa-solid fa-chevron-down text-primary font-size-n75"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "language-list flex-column bg-white pt-2 " + (showLanguageList ? "d-flex" : "d-none"),
                children: languageMenuItems
            })
        ]
    });
};
/* harmony default export */ var header_LanguageSelector = (LanguageSelector);

;// CONCATENATED MODULE: ./components/menu/DesktopMenu.tsx





var DesktopMenu = function(props) {
    var t = (0,Hooks/* useTranslate */.qM)();
    var language = (0,hooks/* useAppStateSelector */.k)(function(state) {
        return state.layout.language;
    });
    /** Menu items */ var cmpMenuItems = props.menuItems.map(function(menuItem) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "desktop-menu-item text-uppercase fw-bold ms-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ALink/* default */.Z, {
                href: config/* default.appUrl */.Z.appUrl + language.code + "/" + menuItem.link,
                className: "text-white",
                children: t(menuItem.name)
            })
        }, menuItem.name);
    });
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "desktop-menu d-flex justify-content-end align-items-center py-1",
        children: cmpMenuItems
    });
};
/* harmony default export */ var menu_DesktopMenu = (DesktopMenu);

;// CONCATENATED MODULE: ./components/header/Header.tsx













var Header = function(props) {
    var t = (0,Hooks/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var dispatch = (0,hooks/* useAppActionDispatch */.a)();
    var instagramPage = AppSetting/* default.getValueFromArray */.Z.getValueFromArray(props.appSettings, "instagram_page");
    var allowCookies = (0,hooks/* useAppStateSelector */.k)(function(state) {
        return state.tracker.allowCookies;
    });
    /** Track pageview */ (0,react.useEffect)(function() {
        if (allowCookies) AppTracker.instance.logPageView();
    }, [
        allowCookies
    ]);
    /** Social icons */ var socialIcons = [
        {
            icon: "fa-brands fa-instagram",
            link: instagramPage.url,
            alt: instagramPage.name
        }
    ];
    var cmpSocialIcons = socialIcons.map(function(socialIcon) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "header-social-icon",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ALink/* default */.Z, {
                href: socialIcon.link,
                target: "_blank",
                className: "text-gray-600 font-size-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: socialIcon.icon + ""
                })
            }, socialIcon.icon)
        }, socialIcon.icon);
    });
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "header-top",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-2 d-lg-none"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "logo-container col-8 col-lg-10 d-flex align-items-center justify-content-center justify-content-lg-start py-1 cursor-pointer",
                                onClick: function() {
                                    return router.push(config/* default.appUrl */.Z.appUrl);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmoothImage/* default */.Z, {
                                        src: config/* default.defaultPublicDirBaseUrl */.Z.defaultPublicDirBaseUrl + "img/logo/logo.png",
                                        width: 150,
                                        height: 150,
                                        className: "logo me-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "logo-text text-uppercase fw-bold font-size-3",
                                        children: t("LOGO_TEXT")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-2 d-flex justify-content-end align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "header-social-icons d-none d-md-block me-3",
                                        children: cmpSocialIcons
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LanguageSelector, {})
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-bottom bg-primary py-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-none d-lg-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_DesktopMenu, {
                                menuItems: props.menuItems
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex d-lg-none justify-content-end py-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa-solid fa-bars text-white font-size-4",
                                onClick: function() {
                                    return dispatch((0,layoutSlice/* setIsMobileMenuOpen */.xe)(true));
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var header_Header = (Header);

;// CONCATENATED MODULE: ./components/layout/Layout.tsx






var Layout = function(props) {
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_MobileMenu, {
                menuItems: props.menuItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Header, {
                menuItems: props.menuItems.filter(function(menuItem) {
                    return menuItem.position == MenuBase/* MenuPosition.Both */.Em.Both || menuItem.position == MenuBase/* MenuPosition.Header */.Em.Header;
                }),
                appSettings: props.appSettings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container page py-4",
                children: props.children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_Footer, {
                menuItems: props.menuItems.filter(function(menuItem) {
                    return menuItem.position == MenuBase/* MenuPosition.Both */.Em.Both || menuItem.position == MenuBase/* MenuPosition.Footer */.Em.Footer;
                }),
                appSettings: props.appSettings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gdpr_CookieConsent, {})
        ]
    });
};
/* harmony default export */ var layout_Layout = (Layout);


/***/ }),

/***/ 6775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EZ": function() { return /* binding */ createMenuItems; },
/* harmony export */   "Em": function() { return /* binding */ MenuPosition; },
/* harmony export */   "M1": function() { return /* binding */ FooterMenuPosition; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var MenuPosition;
(function(MenuPosition) {
    MenuPosition[MenuPosition["Header"] = 0] = "Header";
    MenuPosition[MenuPosition["Footer"] = 1] = "Footer";
    MenuPosition[MenuPosition["Both"] = 2] = "Both";
})(MenuPosition || (MenuPosition = {}));
var FooterMenuPosition;
(function(FooterMenuPosition) {
    FooterMenuPosition[FooterMenuPosition["Position1"] = 0] = "Position1";
    FooterMenuPosition[FooterMenuPosition["Position2"] = 1] = "Position2";
})(FooterMenuPosition || (FooterMenuPosition = {}));
var MenuBase = function(props) {
    /** Render */ return /*#__PURE__*/ _jsx(_Fragment, {});
};
function createMenuItems() {
    var menuItems = [
        {
            name: "ABOUT",
            link: "about",
            position: MenuPosition.Both,
            footerPosition: FooterMenuPosition.Position2
        },
        {
            name: "PORTFOLIO",
            link: "portfolio",
            position: MenuPosition.Both,
            footerPosition: FooterMenuPosition.Position2
        },
        {
            name: "BIOGRAPHY",
            link: "biography",
            position: MenuPosition.Both,
            footerPosition: FooterMenuPosition.Position2
        },
        {
            name: "EXHIBITIONS",
            link: "exhibitions",
            position: MenuPosition.Both,
            footerPosition: FooterMenuPosition.Position2
        },
        {
            name: "CONTACT",
            link: "contact",
            position: MenuPosition.Both,
            footerPosition: FooterMenuPosition.Position2
        },
        {
            name: "IMPRESSUM",
            link: "impressum",
            position: MenuPosition.Footer,
            footerPosition: FooterMenuPosition.Position1
        },
        {
            name: "PRIVACY_POLICY",
            link: "privacy",
            position: MenuPosition.Footer,
            footerPosition: FooterMenuPosition.Position1
        }
    ];
    return menuItems;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (MenuBase)));


/***/ }),

/***/ 4851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export AppSetting */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6626);
/* harmony import */ var _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _xFrame4_business_BusinessEntity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(628);







var AppSetting = /*#__PURE__*/ function(BusinessEntity) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(AppSetting, BusinessEntity);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(AppSetting);
    function AppSetting() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, AppSetting);
        var _this;
        _this = _super.apply(this, arguments);
        _this.value = JSON.stringify({});
        _this.isPublic = true;
        return _this;
    }
    /**
     * Get the value for a setting.
     * 
     * @param name The setting name.
     */ AppSetting.getValue = function getValue(name) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var appSetting;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return AppSetting.manager.get({
                            name: name
                        });
                    case 2:
                        appSetting = _ctx.sent;
                        return _ctx.abrupt("return", appSetting != null ? appSetting.valueAsObject : undefined);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Set the value for a setting.
     * 
     * @param name The setting name.
     * @param value The setting value.
     */ AppSetting.setValue = function setValue(name, value) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var appSetting;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return AppSetting.manager.get({
                            name: name
                        });
                    case 2:
                        appSetting = _ctx.sent;
                        if (appSetting == null) {
                            appSetting = new AppSetting();
                            appSetting.name = name;
                        }
                        appSetting.value = JSON.stringify(value);
                        _ctx.next = 7;
                        return appSetting.save();
                    case 7:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Delete a setting.
     * 
     * @param name The setting name.
     */ AppSetting.delete = function _delete(name) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var appSetting;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return AppSetting.manager.get({
                            name: name
                        });
                    case 2:
                        appSetting = _ctx.sent;
                        if (!(appSetting != null)) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return appSetting.delete();
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Set the visibility (public or not) for a setting.
     * 
     * @param name The setting name.
     * @param isPublic Is it visible without logging in as an admin?
     */ AppSetting.setVisibility = function setVisibility(name, isPublic) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var appSetting;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return AppSetting.manager.get({
                            name: name
                        });
                    case 2:
                        appSetting = _ctx.sent;
                        if (!(appSetting != null)) {
                            _ctx.next = 7;
                            break;
                        }
                        appSetting.isPublic = isPublic;
                        _ctx.next = 7;
                        return appSetting.save();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * Get a setting value from an array of settings.
     * 
     * @param appSettings An array of AppSetting objects.
     * @param name The name of the setting.
     * @returns The value as object.
     */ AppSetting.getValueFromArray = function getValueFromArray(appSettings, name) {
        var appSetting = appSettings.find(function(s) {
            return s.name == name;
        });
        if (appSetting) {
            return appSetting.valueAsObject;
        } else {
            return undefined;
        }
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(AppSetting, [
        {
            key: "valueAsObject",
            get: /** 
     * Return the value as an object.
     */ function get() {
                return JSON.parse(this.value);
            }
        }
    ]);
    return AppSetting;
}(_xFrame4_business_BusinessEntity__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP);
AppSetting.manager = new _xFrame4_business_BusinessEntity__WEBPACK_IMPORTED_MODULE_1__/* .EntityManager */ .v2({
    name: "AppSetting",
    createEntity: function() {
        return new AppSetting();
    },
    fields: [
        {
            name: "name",
            isRequiredInput: true
        },
        {
            name: "value",
            isRequiredInput: true
        },
        {
            name: "isPublic",
            isRequiredInput: true
        }, 
    ],
    graphQlQueryAlias: "appSettings"
});
/* harmony default export */ __webpack_exports__["Z"] = (AppSetting);


/***/ }),

/***/ 5423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xFrame4_common_Functions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8658);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);






/**
* Get the image src from the props.src and modify it if necessary. 
* (for now: only the fresh image URL can be applied) 
*/ function getImageSrc(imageSrc, createFreshImageUrl) {
    return createFreshImageUrl ? (0,_xFrame4_common_Functions__WEBPACK_IMPORTED_MODULE_2__/* .freshImageUrl */ .Us)(imageSrc) : imageSrc;
}
/**
 * Renders an image that loads smoothly, lazily and responsively.
 * 
 * @param props 
 */ var SmoothImage = function(props) {
    var ref;
    var img = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.enableLazyLoading ? "" : getImageSrc(props.src, props.createFreshImageUrl)), src = ref1[0], setSrc = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!props.enableLazyLoading), triggerLazyLoading = ref2[0], setTriggerLazyLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isImageLoaded = ref3[0], setIsImageLoaded = ref3[1];
    /** If props.src changes: the src state will only change if the previous src has been already loaded. */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isImageLoaded) setSrc(getImageSrc(props.src, props.createFreshImageUrl));
    }, [
        props.src
    ]);
    /** Check if the HTMLImageElement has been loaded. */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if (((ref = img.current) === null || ref === void 0 ? void 0 : ref.complete) === true) {
            setIsImageLoaded(true);
            if (props.onLoaded) props.onLoaded();
        }
    }, [
        (ref = img.current) === null || ref === void 0 ? void 0 : ref.complete
    ]);
    /** Lazy load check on scroll. Does not work if lazyLoadBreakpoints are set. */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var onScroll = function() {
            if ((0,_xFrame4_common_Functions__WEBPACK_IMPORTED_MODULE_2__/* .isElementAboveThreshold */ .Ri)(img.current, props.lazyLoadPixelTreshold)) {
                if (props.lazyLoadBreakpoints === undefined) setTriggerLazyLoading(true);
            }
        };
        document.addEventListener("scroll", onScroll);
        //cleanup: remove scroll event listener
        return function() {
            document.removeEventListener("scroll", onScroll);
        };
    }, []);
    /** 
     * Load the image if lazy loading is enabled and it's already above the screen bottom when loading the page. 
     * Does not work if lazyLoadBreakpoints are set.
     * Sometimes a minHeight has to be set via the props.style property, because browsers do not respect the aspect ratio early on when loading the page (the height is very small), and lazy load will be triggered for the other images on the page (because they will be in the screen).
     */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.enableLazyLoading && (0,_xFrame4_common_Functions__WEBPACK_IMPORTED_MODULE_2__/* .isElementAboveThreshold */ .Ri)(img.current, 0)) {
            if (props.lazyLoadBreakpoints === undefined) setTriggerLazyLoading(true);
        }
    }, []);
    /** Load the image if lazy loading is enabled and the lazy load breakpoint settings enable it. */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.lazyLoadBreakpoints != undefined && props.lazyLoadBreakpoints.length > 0) {
            // Get the screen width
            var windowWidth = window.innerWidth;
            // Get all breakpoints that are less than the screen width and sort them ASC
            var lazyLoadBreakpoints = props.lazyLoadBreakpoints.sort(function(a, b) {
                return a.minBreakpoint - b.minBreakpoint;
            }).filter(function(bp) {
                return bp.minBreakpoint <= windowWidth;
            });
            // If the largest filtered breakpoint enables the lazy loading: trigger the lazy loading
            if (lazyLoadBreakpoints.length > 0 && lazyLoadBreakpoints[lazyLoadBreakpoints.length - 1].load) {
                setTriggerLazyLoading(true);
            }
        }
    }, []);
    /** Trigger the lazy loading, set the src from the img. */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (triggerLazyLoading) setSrc(getImageSrc(props.src, props.createFreshImageUrl));
    }, [
        triggerLazyLoading
    ]);
    /** Render */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: src,
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props.style), {
            transition: "opacity",
            transitionDuration: props.enableLazyLoading ? "300ms" : "0s",
            opacity: !props.enableLazyLoading ? 1 : isImageLoaded ? 1 : 0
        }),
        className: "smooth-image " + props.className,
        ref: img,
        width: props.width,
        height: props.height,
        alt: props.alt,
        onClick: props.onClick,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave
    });
};
SmoothImage.defaultProps = {
    enableLazyLoading: false,
    lazyLoadPixelTreshold: 300,
    className: "",
    style: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (SmoothImage);


/***/ }),

/***/ 2768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


/** React Component: Wrapper around the Next.js Link component. */ var ALink = function(props) {
    var defaultFunction = function(e) {
        if (props.href == "#") {
            e.preventDefault();
        }
        if (props.onClick) props.onClick();
    };
    /** Render */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: props.href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: props.className,
            style: props.style,
            target: props.target,
            onClick: function(e) {
                return defaultFunction(e);
            },
            children: props.children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ALink);


/***/ }),

/***/ 4685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _redux_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6410);




var CustomHead = function(props) {
    var ref, ref1, ref2, ref3;
    var appLanguage = (0,_redux_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useAppStateSelector */ .k)(function(state) {
        return state.layout.language;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.documentElement.setAttribute("lang", appLanguage.code);
    }, [
        appLanguage
    ]);
    /** Render */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                ((ref = props.metaData) === null || ref === void 0 ? void 0 : ref.title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: props.metaData.title
                }),
                ((ref1 = props.metaData) === null || ref1 === void 0 ? void 0 : ref1.metaDescription) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: props.metaData.metaDescription
                }),
                ((ref2 = props.metaData) === null || ref2 === void 0 ? void 0 : ref2.metaKeywords) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: props.metaData.metaKeywords
                }),
                ((ref3 = props.metaData) === null || ref3 === void 0 ? void 0 : ref3.ogMeta) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        props.metaData.ogMeta.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:title",
                            content: props.metaData.ogMeta.title
                        }),
                        props.metaData.ogMeta.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:description",
                            content: props.metaData.ogMeta.description
                        }),
                        props.metaData.ogMeta.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:url",
                            content: props.metaData.ogMeta.url
                        }),
                        props.metaData.ogMeta.type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:type",
                            content: props.metaData.ogMeta.type
                        }),
                        props.metaData.ogMeta.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                props.metaData.ogMeta.image.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    property: "og:image",
                                    content: props.metaData.ogMeta.image.url
                                }),
                                props.metaData.ogMeta.image.type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    property: "og:image:type",
                                    content: props.metaData.ogMeta.image.type
                                }),
                                props.metaData.ogMeta.image.width && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    property: "og:image:width",
                                    content: props.metaData.ogMeta.image.width.toString()
                                }),
                                props.metaData.ogMeta.image.height && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    property: "og:image:height",
                                    content: props.metaData.ogMeta.image.height.toString()
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomHead);


/***/ })

}]);